function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
  try {obsTrek.disconnect()} catch(e) {console.log('no-obsTrek')}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
  /*
   * Speedopz Optimization JS
   *
   */

  let afL1=3500,afL2=500; 
  let FN=(e)=>{e.forEach(Function.prototype.call,Function.prototype.call)}; let DFc=(e)=>{for(let t=0;t<e.length;t++){SSl(e[t])}};
  let setCookie=(n, v, t)=>{const d = new Date(); d.setTime(d.getTime() + (t*24*60*60*1000)); let exp = "expires="+ d.toUTCString(); document.cookie = n + "=" + v + ";" + exp + ";path=/";}
  let UL=(e)=>{for(let t=0;t<e.length;t++){let n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=e[t];let i=document.getElementsByTagName("script")[0];i.parentNode.insertBefore(n,i)}}
  let EXs=(e)=>{for(z=[],a=e.split(" "),i=0;i<a.length;i++)a[i].startsWith("src=")?z[i]="s."+a[i]+", ":a[i].startsWith("defer")?z[i]="":(b=a[i].replace(/=/,'", '),z[i]='s.setAttribute("'+b+"), ");return p=z.join(" "),p.replace(/, $/,"").replace(/crossorigin/g,"crossOrigin")}
  let EX=(e)=>{c="";for(let t=0;t<e.length;t++)b=EXs(e[t]),c+="s=document.createElement('script'), s.type='text/javascript',"+b+", document.head.appendChild(s);";let n=document.createElement("script");n.type="text/javascript",n.textContent=c,document.head.appendChild(n)}
  let LdM=()=>{const t=document.querySelectorAll('SCRIPT[type="text/deferTrek"]');t.forEach(t=>{let e=document.createElement("script");e.type="text/javascript",t.src?(e.src=t.src,e.id=t.id,e.crossOrigin="anonymous"):(e.textContent=t.textContent,e.id=t.id),e.async=!1,Object.assign(e.dataset,t.dataset),t.parentNode.removeChild(t),document.body.appendChild(e)})};trekLoad.push(LdM);
  let speedLoader=()=>{themeCheck();FN(theme2Arr);setTimeout(()=>{DFc(DFl);FN(trekLoad),EX(extArr),setTimeout(()=>{UL(afUrls),FN(trkArr),setTimeout(()=>{FN(barArr);themeCheck();},afL1)},afL2)},afL1)};window.attachEvent?window.attachEvent("onload",speedLoader):window.addEventListener("load",speedLoader,!1);
  
/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};





let imgSelect=(a)=>{
  if(a.hasAttribute('data-active-img')){a.removeAttribute('data-active-img')}

  if(a.classList.contains('img-all')){ 
     if(docWidth >749){ 
       let imgM = a.getAttribute('data-dsk') || 1000; 
       let imgU = a.getAttribute('data-src').replace(/&width=\d+/, '&width='+imgM ).replace(/_\d+x\./, '_'+imgM+'x.'); 
       a.setAttribute('data-src', imgU );
     }
   }
 
   let imgUrl = a.getAttribute('data-src');
 
   if(a.classList.contains('jsLazy')) {
       a.classList.remove('jsLazy','jsProcess');
       a.classList.add('lazyload','jsProcessed');
     
     } else if(docWidth >749){
        if(a.classList.contains('img-desk') || a.classList.contains('img-all')){
            a.setAttribute('src', imgUrl);
            a.classList.remove('jsProcess');
            a.classList.add('jsProcessed'); 
            a.setAttribute('data-active-img','');
        } 
      } else if(docWidth<750 && docWidth>419){
     if(a.classList.contains('img-tab') || a.classList.contains('img-all')){
       a.setAttribute('src', imgUrl);
       a.classList.remove('jsProcess');
       a.classList.add('jsProcessed'); 
       a.setAttribute('data-active-img','');
   }
     } else if(docWidth<420){ 
       if(a.classList.contains('img-mob') || a.classList.contains('img-all')){
         if (a.hasAttribute('data-src')){a.setAttribute('src', imgUrl)};
       a.classList.remove('jsProcess');
       a.classList.add('jsProcessed'); 
       a.setAttribute('data-active-img','');
     }
    	}	else { 
       console.log('some images not processed')
     }

 }
let imgProcess=()=>{let processImages = document.querySelectorAll('img.jsProcess'); processImages.forEach((e) => {imgSelect(e)})}
let spdLazySsl=()=>{document.querySelectorAll('[data-ssl]').forEach(el=>{el.classList.add('lazyload'); el.addEventListener('lazybeforeunveil',ev=>{SSl(ev.target.dataset.ssl)})})}; 
let spdLazySsc=()=>{document.querySelectorAll('[data-ssc]').forEach(el=>{el.classList.add('lazyload'); el.addEventListener('lazybeforeunveil',ev=>{UL([ev.target.dataset.ssc])})})}; 
let spdLazyElement=()=>{document.querySelectorAll('.spdLazy').forEach((e) => {e.classList.remove('spdLazy'),e.classList.add('lazyload')})};
themeArr.push(spdLazySsl);
themeArr.push(spdLazySsc);
themeChecks.push(imgProcess);
themeChecks.push(spdLazyElement);


let themeCheck=()=>{ 
  docWidth=document.documentElement.clientWidth;
  headerHeight=document.querySelector('header').offsetHeight; 
  try{FN(themeChecks);console.log('checked');}catch{console.log('notchecked');}
}
let reSizing; window.onresize=()=>{clearTimeout(reSizing);reSizing=setTimeout(themeCheck, 100)}







class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('div.shopify-section.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    try{this.header.classList.remove('menu-open')}catch{console.log('menu-closed')}
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
      this.dataSnap = JSON.parse(this.slider.getAttribute('data-snap'));
      this.dataNumb = parseInt(this.slider.getAttribute('data-numb'));
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if(this.dataSnap){this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (this.slider.clientWidth / this.dataNumb) : this.slider.scrollLeft - (this.slider.clientWidth / this.dataNumb);} 
      else {this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);}
      this.slider.scrollTo({left: this.slideScrollPosition}); 
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    setTimeout(() => {this.fixHeight()});
    
    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    if(!this.classList.contains('none')) {
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
    }
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  fixHeight(){
     if(this.hasAttribute('data-fix-height')) {
       let slide1 = this.sliderFirstItemNode;
       let sldrH;
       try{let p =(slide1.querySelector('img[data-active-img]').getAttribute('height') / slide1.querySelector('img[data-active-img]').getAttribute('width')); sldrH = (slide1.offsetWidth * (p));console.log(sldrH)}
       catch{sldrH=slide1.querySelector('div').offsetHeight; console.log(sldrH)}
       finally{this.sliderItems.forEach(el=>{el.style.height=sldrH+'px'})}
     }
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
      this.select = this.querySelector('variant-selects .product-form__input .select') || this.querySelector('variant-radios fieldset.product-form__input');
      this.selector = this.querySelector('select.select__select') || this.querySelector('fieldset');
      
  }

  onVariantChange() {
      if (this.select.classList.contains('option-reselect')){this.select.classList.remove('option-reselect')}
      else if (this.selector.value == 'select'){this.select.classList.add('option-reselect')}
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updatePresaleDate();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
        const input = productForm.querySelector('[name="items[0]id"]') || productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePresaleDate() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
        const input = document.querySelector('[name="properties[Note]"]');
        const title = document.querySelector('.product__title');
        const productInfoWrapper = document.querySelector('.product__info-wrapper');
        const GlobalPresaleBox = document.querySelector('.spd__Global-presale_tag'); 
      
        let matchingvar = document.querySelector('[data-variantidxh="'+this.currentVariant.id+'"]');
        if(matchingvar && matchingvar.dataset.variantpresale != '' && matchingvar.dataset.variantpresale != 'In Stock'  && matchingvar.dataset.variantpresale != undefined ){
          input.value = matchingvar.dataset.variantpresale;
          // title.innerHTML = title.dataset.titleorg + ' (' + matchingvar.dataset.variantpresale + ')';
          // productInfoWrapper.classList.add('preOrder')
          // productInfoWrapper.classList.remove('available');
          // GlobalPresaleBox.querySelector('strong').innerHTML = matchingvar.dataset.variantpresale; 
        } else {
          input.value = '';
          // title.innerHTML = title.dataset.titleorg; 
          // productInfoWrapper.classList.remove('preOrder')
          // productInfoWrapper.classList.add('available')
          // GlobalPresaleBox.querySelector('strong').innerHTML = 'Ships on'; 
        }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        try{
          let financePrice=html.querySelector('span.finance-price').innerHTML; 
          document.querySelectorAll('span.finance-price').forEach(el=>{el.innerHTML=financePrice})
        }catch{};

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

  class BundleSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.select = this.querySelector('select') || this.querySelector('fieldset>input[type=radio]:checked')
      this.selector = this.querySelector('div.select');
      this.discValue = this.dataset.discValue;
       this.currentPrd = document.querySelector('.product');
      this.prdMediaGallery = document.querySelector('.product__media-galleryxh');
      this.ctaBtns = this.querySelectorAll('.bundle-cta .ctabtn');
      this.tabHandler();

      this.ctaBtns.forEach(el=>{
          el.addEventListener('click', (ev) => {
            this.ctaBtns.forEach(elm=>{ elm.classList.remove('active'); })
            ev.target.classList.add('active');
            
            if(ev.target.dataset.design == 'pattern'){
              this.checkedInp = this.querySelector('fieldset input[type=radio]:checked');
              if(this.checkedInp) { this.prdMediaGallery.classList.add('patternenabled') }
              this.currentPrd.classList.add('pattern');
              el.closest('bundle-selects').classList.add('bundle-pattern-images');
            }
            else{
              this.currentPrd.classList.remove('pattern');
              el.closest('bundle-selects').classList.remove('bundle-pattern-images');
            }
         });  
      });
    }
    
    onVariantChange() {setTimeout(() => {
     let variantValue;
     
      try{variantValue = this.select.value;}
      catch{ 
        this.querySelector('input[type=radio][data-input="select"]').checked=false;
        variantValue = this.querySelector('fieldset input[type=radio]:checked').value;
      }
      finally {
            if (variantValue == 'unavailable') {
                  this.updateDetailsFailed();
                  try{this.select.value = 'select';this.selector.classList.add('option-reselect');}
                  catch{this.querySelector('fieldset input[value="select"]').checked=true; this.querySelector('fieldset').classList.add('option-reselect');}
                  finally{this.currentVariant = 'select';}
              } 
            else {
                  if (variantValue != 'select'){
                      try{this.querySelector('.option-reselect').classList.remove('option-reselect');}catch{}
                      this.currentVariant = variantValue;
                    }
                  this.querySelector('.form__label').classList.add('is-checked');
                  this.updateDetailsSuccess();
               }
               this.updateDetails(); 
               this.updateVariantTotal();
         }
    }, 30)}
    
    updateDetailsSuccess(){
      try{
			this.querySelector('summary').classList.add('is-checked');
            this.querySelector('summary').classList.remove('has-error');
		}
      catch{}
    }
    updateDetailsFailed(){
      try{
			this.querySelector('summary').classList.add('has-error');
            this.querySelector('summary').classList.remove('is-checked');
		}
      catch{}
    }
    
    updateDetails(){
      try{
        let prd = document.querySelector('.product');
        let prdMediaGallery = document.querySelector('.product__media-galleryxh');
		this.querySelector('span.selected-option').innerText = this.querySelector('fieldset input[type=radio]:checked').dataset.title;
        var src = this.querySelector("fieldset input[type=radio]:checked").dataset.imgsrc;
		if (src === undefined)
			return;
		document.querySelector(".product__media-list .is-active img").src = src;
        if(prd.classList.contains('pattern')){
          prdMediaGallery.classList.add('patternenabled');
        } else {
           prdMediaGallery.classList.remove('patternenabled');
        }
      }
      catch{}
    }
    tabHandler(){
      if (this.classList.contains('accordion')) {
        this.querySelector('details').addEventListener('click', this.closeTabs);
        this.querySelector('details').addEventListener('click', this.styleSelection);
      } else {return}
    }

  
    closeTabs(){
      if (!this.hasAttribute('open')) {
        let accordionSelectors = document.querySelectorAll('bundle-selects[data-auto-close]>details');
        accordionSelectors.forEach(el=>{
          el.querySelector('summary').setAttribute('aria-expanded', false); 
          try{el.removeAttribute('open')}catch{};
        })
      }
    }
    styleSelection(){
      this.currentPrd = document.querySelector('.product');
      let prdMediaGallery = document.querySelector('.product__media-galleryxh');
      this.currentStyle = this.querySelector('.ctabtn.active');
      
      if (!this.hasAttribute('open') && this.currentStyle) {
        this.currentStyle = this.querySelector('.ctabtn.active');
        
        if(this.currentStyle.dataset.design == 'pattern'){
            this.currentPrd.classList.add('pattern')
        } else {
            this.currentPrd.classList.remove('pattern')
        }
        var srcelm = this.querySelector("fieldset input[type=radio]:checked");
         if (srcelm === undefined || srcelm === null){
                prdMediaGallery.classList.remove('patternenabled')
                return;
         } else {
            var src = srcelm.dataset.imgsrc
            document.querySelector(".product__media-list .is-active img").src = src;
            prdMediaGallery.classList.add('patternenabled')
         }  
      }
    }
    updateVariantTotal(){
      if (this.hasAttribute('data-variant-price')) {
        let variantPrices = document.querySelectorAll('bundle-selects[data-variant-price]');
        let variantTotal = 0;
        let defaultMin = false;
        variantPrices.forEach(el=>{
          try{
            let varId = el.querySelector('select').value; 
            let price = el.querySelector('select>option[value="'+varId+'"]').dataset.varPrice; 
            if (price == 'select') {defaultMin = true} 
            else {variantTotal += parseInt(price);}
          }catch{
            try{variantTotal += parseInt(el.querySelector('fieldset input[type=radio]:checked').dataset.varPrice)}catch{defaultMin = true} 
          } 
        })

          if (defaultMin){variantTotal = document.querySelector('.spd__grid__item.product__info-wrapper').dataset.prodMin};
          let salePrice = (variantTotal - document.querySelector('.spd__grid__item.product__info-wrapper').dataset.discValue);

            document.querySelector('.price__sale s.price-item.price-item--regular.p').innerHTML = '$'+(variantTotal / 100 )+'<sup>*</sup>';
            document.querySelector('span.price-item.price-item--sale.price-item--last.p').innerHTML = '$'+(salePrice / 100 )
      }
    }
    }
  
  customElements.define('bundle-selects', BundleSelects);

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.isOpen = false;
  
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      const form = this.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));
  
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }
  
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
      const searchTerm = this.getQuery();
  
      if (!searchTerm.length) {
        this.close(true);
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
  
    onFocus() {
      const searchTerm = this.getQuery();
  
      if (!searchTerm.length) return;
  
      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      })
    }
  
    onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();
  
      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up')
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }
  
    onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (
        event.code === 'ArrowUp' ||
        event.code === 'ArrowDown'
      ) {
        event.preventDefault();
      }
    }
  
    switchOption(direction) {
      if (!this.getAttribute('open')) return;
  
      const moveUp = direction === 'up';
      const selectedElement = this.querySelector('[aria-selected="true"]');
      const allElements = this.querySelectorAll('li');
      let activeElement = this.querySelector('li');
  
      if (moveUp && !selectedElement) return;
  
      this.statusElement.textContent = '';
  
      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
      }
  
      if (activeElement === selectedElement) return;
  
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
  
      this.setLiveRegionText(activeElement.textContent);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
  
    selectOption() {
      const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
  
      if (selectedProduct) selectedProduct.click();
    }
  
    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();
  
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
  
      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
  
      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }
  
    setLiveRegionText(statusText) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
  
      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  
    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
  
      this.setLiveRegionResults();
      this.open();
    }
  
    setLiveRegionResults() {
      this.removeAttribute('loading');
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
  
    getResultsMaxHeight() {
      this.sectionHeader = document.getElementById('shopify-section-spd-header') || document.getElementById('shopify-section-header');
      this.resultsMaxHeight = window.innerHeight - this.sectionHeader.getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }
  
    open() {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }
  
    close(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
  
      const selected = this.querySelector('[aria-selected="true"]');
  
      if (selected) selected.setAttribute('aria-selected', false);
  
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false
      this.predictiveSearchResults.removeAttribute('style');
  
      this.isOpen = false;
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);  
  
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
          this.details = this.querySelector('details');
          if (this.details.hasAttribute('data-auto-close')){
            this.details.onclick=()=>this.closeTabs();
          }
    
    }
    closeTabs(){
      console.log('tabby');
      if (!this.details.hasAttribute('open')) {
        let cTabs = document.querySelectorAll('collapsible-tab>[data-auto-close]');
        cTabs.forEach(el=>{
          el.querySelector('summary').setAttribute('aria-expanded', false); 
          try{el.removeAttribute('open')}catch{};
        })
      } else {this.details.setAttribute('open', '')}
    }
    
  }
  customElements.define('collapsible-tab', CollapsibleTab);
	
  class ColorSwatches extends HTMLElement {
    constructor() {
        super();
        document.querySelectorAll('.swatch label').forEach((spn) => {
          spn.addEventListener('click', (event) => {
            this.renderProductInfo(spn);
          });
        });
    }
    renderProductInfo(spn) {
      window.location = spn.dataset.url
    }
  }  
  customElements.define('color-swatches', ColorSwatches);   

  class SpdMegaMenu extends HTMLElement {
    constructor() {
      super();
          this.details = this.querySelector('details');
          this.topLinks=this.querySelectorAll('.spd-mm_link-lvl1');
    
          this.topLinks.forEach(el=>this.hoverClassChange(el, 'currentHover'));
          this.clickDetailsOpen();
          if(this.classList.contains('hoverOpen')) {this.hoverDetailsOpen(this)}
    }
   
    hoverClassChange(a,b){a.onmouseover=()=>{try{this.querySelector('.currentHover').classList.remove('currentHover')}catch{}finally{a.classList.add(b)}}; if(a.classList.contains('loadImages')){this.processImages(a)}}

    clickDetailsOpen(){this.onclick=()=>{this.details.removeAttribute('open',''); this.details.classList.toggle('clickHold')}}

    hoverDetailsOpen(){this.onmouseover=()=>{this.details.setAttribute('open','')};this.onmouseleave=()=>{if (!this.details.classList.contains('clickHold')){this.details.removeAttribute('open')}}}

    processImages(a){let processImg=a.querySelectorAll('a.spd__image>.img-spd__image>img.spd-mm-img'); processImg.forEach(img=>img.classList.add('lazyload'));}
  }
  customElements.define('spd-mega-menu', SpdMegaMenu);
  



  let lItr = 1; let fNS=(e, t, i)=>{lItr += 1;let s = document.getElementById(e), n = location.pathname + "?page=" + lItr;
  fetch(n).then(e=>e.text()).then(e=>e.replace(/<noscript>(.|\n)+?<\/noscript>/g, "")).then(n=>{let o = (new DOMParser).parseFromString(n, "text/html").getElementById(e);o.classList.contains("collection--empty") || (s.setAttribute("id", e + "-" + lItr),
  document.getElementById(t).appendChild(o),setTimeout(()=>{FN(themeChecks), document.getElementById(i).classList.replace("lazyloaded", "lazyload")}, 100))})}

  
FN(themeArr);
themeCheck();

  let spdZoomImg=(zim)=>{ 
    zim.onmouseover=()=>{zim.classList.add('zooming')};zim.onmouseleave=()=>{ zim.classList.remove('zooming');  zim.removeAttribute('style');};zim.onmousemove=(e)=>{ zm=1.5; zn=((zm-1)*50); h=(zim.offsetHeight); w=(zim.offsetWidth); x=e.offsetX; y=e.offsetY;
    hn=(h/zm/2);wn=(w/zm/2); xs=(x-((w*zm)-w)); ys=(y-((h*zm)-h)); wp=((zn/wn)*xs).toFixed(2); hp=((zn/hn)*ys).toFixed(2); styl= 'translate('+(wp-wp-(wp/zm))+'%, '+(hp-hp-(hp/zm))+'%)'; zim.style.transform=styl; }}; 
  document.querySelectorAll('.spd--img-wrapper.mouseTrack').forEach(el=>spdZoomImg(el)); document.querySelectorAll('.spd__flxiSlide.product__media-item>[data-zoom-active]').forEach(el=>spdZoomImg(el));      

 let spdHoverExp =(hv)=>{ let mD = hv.querySelector('details') || hv.querySelector('a');
    if (mD.tagName == 'DETAILS'){
      hv.onmouseover=()=>{mD.setAttribute('open','')};
      hv.onmouseleave=()=>{mD.removeAttribute('open')};
    }
 };document.querySelectorAll('nav.hoverOpen > .list-menu--inline > li').forEach(el=>spdHoverExp(el));

 


